import springKeyframes from 'spring-keyframes'
import { css } from 'emotion'

const spring = {
  damping: 0.8,
  stiffness: 0.5,
}

const springs = {
  soft: {
    damping: 0.65,
    stiffness: 0.5,
  },
  softest: {
    damping: 0.6,
    stiffness: 0.45,
  },
}

function createMovement({ from, to }, amount) {
  return css`
    animation: ${springKeyframes(
        { from, to },
        amount ? springs[amount] : spring
      )}
      1s linear 1 !important;
    animation-fill-mode: forwards !important;
  `
}

export const hash = s => {
  // https://gist.github.com/iperelivskiy/4110988
  var a = 1,
    c = 0,
    h,
    o
  if (s) {
    a = 0
    for (h = s.length - 1; h >= 0; h--) {
      o = s.charCodeAt(h)
      a = ((a << 6) & 268435455) + o + (o << 14)
      c = a & 266338304
      a = c !== 0 ? a ^ (c >> 21) : a
    }
  }
  return String(a)
}

export function springY(y, amount) {
  return createMovement({ from: { y: 0 }, to: { y } }, amount)
}

export function slugify(text) {
  return text.toLowerCase().replace(/ /gi, '-')
}

export const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

export const springIn40 = springKeyframes(
  {
    from: {
      y: 40,
    },
    to: {
      y: 0,
    },
  },
  spring
)
export const springIn60 = springKeyframes(
  {
    from: {
      y: 60,
    },
    to: {
      y: 0,
    },
  },
  spring
)



// WEBPACK FOOTER //
// ../api/src/utils.js